import { useQuery } from 'react-query';
import { helpCenterApi } from '../Api/help-center';
import {
  AnnouncementLogs,
  HelpCenterData,
} from '../../Components/HelpCenter/types';

export const useHelpCenterData = (userId: string) =>
  useQuery<HelpCenterData>({
    queryKey: ['helpCenter', userId],
    queryFn: () => helpCenterApi.getHelpCenterData(userId),
    refetchOnWindowFocus: false,
  });

export const useAnnouncementLogs = (userId: string) =>
  useQuery<AnnouncementLogs>({
    queryKey: ['announcementLogs', userId],
    queryFn: () => helpCenterApi.getAnnouncementLogs(userId),
    refetchOnWindowFocus: false,
  });
